module.exports = __webpack_public_path__ + "static/media/arrow_forward_off.792e24ca.svg";